import { appQueryClient } from '@libs/data-access/queries'

export const contractDpaeQueryKeys = {
  fetch_dpae_contract: (queryParams = {}) => [
    'fetch_dpae_contract',
    queryParams
  ],
  post_dpae_contract: () => ['post_dpae_contract'],
  post_dpae_contracts_bulk: () => ['post_dpae_contracts_bulk']
}

export const contractDpaeInvalidation = {
  invalidate_dpae_contract: params => {
    appQueryClient.invalidateQueries({
      queryKey: contractDpaeQueryKeys.fetch_dpae_contract(params)
    })
  }
}
